import React, { useState, useEffect } from 'react';
import ForexHeader from '../features/Forex/components/ForexHeader';
import ForexFigures from '../features/Forex/components/ForexFigures';
import CurrencyCharts from '../features/Forex/components/CurrencyCharts';
import CurrenciesBarChart from '../features/Forex/components/charts/CurrenciesBarChart';
import AddCurrencyModal from '../features/Forex/components/modals/AddCurrencyModal';
import { useCurrencyStore } from '../features/Forex/store/currencyStore';
import ExchangeRateTable from '../features/Forex/components/ExchangeRateTable';

const ForexContent: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { currencies, fetchCurrencies } = useCurrencyStore();

  // fetch on mount
  useEffect(() => {
    fetchCurrencies();
  }, [fetchCurrencies]);

  return (
    <div className='w-full py-6'>
      <ForexHeader />
      <ForexFigures onClick={() => setIsOpen(true)} currencies={currencies} />
      <CurrencyCharts />
      <CurrenciesBarChart />
      <ExchangeRateTable />

      <AddCurrencyModal 
        isOpen={isOpen} 
        onClose={() => setIsOpen(false)} 
        onSuccess={() => {
          fetchCurrencies();
          setIsOpen(false);
        }} 
      />
    </div>
  );
};

export default ForexContent;
